module.exports = window.__NOOP__;